import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiUserFollowStateVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
}>;


export type ApiUserFollowState = { userFollowState: { followingCount: number, followerCount: number, isFollowing: boolean } };



export const ApiUserFollowStateDocument = /*#__PURE__*/ `
    query UserFollowState($publicKey: String!) {
  userFollowState(accountAddress: $publicKey) {
    isFollowing: isFollowingUser
    followingCount
    followerCount
  }
}
    `;

export const useUserFollowState = <
      TData = ApiUserFollowState,
      TError = ClientError
    >(
      variables: ApiUserFollowStateVariables,
      options?: Omit<UseQueryOptions<ApiUserFollowState, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiUserFollowState, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiUserFollowState, TError, TData>(
      {
    queryKey: ['UserFollowState', variables],
    queryFn: apiFetcher<ApiUserFollowState, ApiUserFollowStateVariables>(ApiUserFollowStateDocument, variables),
    ...options
  }
    )};

useUserFollowState.getKey = (variables: ApiUserFollowStateVariables) => ['UserFollowState', variables];

export const useInfiniteUserFollowState = <
      TData = InfiniteData<ApiUserFollowState>,
      TError = ClientError
    >(
      variables: ApiUserFollowStateVariables,
      options: Omit<UseInfiniteQueryOptions<ApiUserFollowState, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiUserFollowState, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiUserFollowState, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['UserFollowState.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiUserFollowState, ApiUserFollowStateVariables>(ApiUserFollowStateDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserFollowState.getKey = (variables: ApiUserFollowStateVariables) => ['UserFollowState.infinite', variables];


useUserFollowState.fetcher = (variables: ApiUserFollowStateVariables, options?: RequestInit['headers']) => apiFetcher<ApiUserFollowState, ApiUserFollowStateVariables>(ApiUserFollowStateDocument, variables, options);
